// import config from "../config/config";
// const {API_BASE_URL} = config;
const dummyData = { 
  contents: [

    {
  "id": 1,
  "type": "video",
  "title": "HLS Test",
  "url": "https://devstreaming-cdn.apple.com/videos/streaming/examples/adv_dv_atmos/main.m3u8"
}
  ]
};

export default dummyData;